<template>
    <div class="section full mb-3">
            <div class="section-title">جستجو استانی</div>
            <ul class="listview image-listview placeholder-glow mb-2">
                <li>
                    <a href="#" class="item">
                        <div class="in">
                            <span class="placeholder col-4"></span>
                            <span class="placeholder col-2"></span>
                        </div>
                    </a>
                </li>
                <li>
                    <a href="#" class="item">
                        <div class="in">
                            <span class="placeholder col-4"></span>
                            <span class="placeholder col-2"></span>
                        </div>
                    </a>
                </li>
                <li>
                    <a href="#" class="item">
                        <div class="in">
                            <span class="placeholder col-4"></span>
                            <span class="placeholder col-2"></span>
                        </div>
                    </a>
                </li>
            </ul>
            
        </div>
</template>
<script>
export default {
    
}
</script>
<style>
    
</style>